export class PartnerIntegration {

    constructor (values={}) {
        this.attributes = {
            event_type: null,
            nm: null,
            add: null,
            ct: null,
            st: null,
            zip: null,
            sdt: null,
            edt: null,
            tz: null,
            hn: null,
            et: null,
            ph: null,
            mess: null,
            mess_link: null
        };
        this.save = false;
        for (let k of Object.keys(this.attributes)) {
            let passed = values[k] || getURLParameter(k);
            this.attributes[k] = passed;
            if (k !== 'event_type' && passed) {
                this.save = true;
            }
        }

        if (this.save) {
            store.set("partner_ev", this.attributes, {
                TTL: 600000
            });
        }
    };

    fetch () {
        var data;
        data = store.get("partner_ev");
        store.remove("partner_ev");
        return data;
    };
}

export default PartnerIntegration;



// WEBPACK FOOTER //
// ./assets/es6/common/partner_integration.es6